<template>
  <div class="pointer-events-none fixed inset-x-0 bottom-28 z-[90] flex justify-center px-4" v-if="show">
    <button
      class="pointer-events-auto flex items-center gap-3 rounded-full px-5 py-3 text-sm shadow-lift ring-1 ring-white/10 backdrop-blur-xl transition-all animate-slide-up"
      :class="['notification', type]" @click="close" v-if="message" aria-label="Dismiss notification">
      <span>{{ message }}</span>
      <span class="icon-x text-xs opacity-70"></span>
    </button>
  </div>
</template>
  
<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const show = computed(() => store.state.notification.show);

const message = computed(() => store.state.notification.message);

let type = computed(() => store.state.notification.type);

const close = () => {
  store.dispatch('notification/closeNotification');
};
</script> 
<style >
.notification {
  @apply font-medium;
}

.notification.warning {
  @apply bg-yellow-600;
  @apply text-nomad-900;
}

.notification.success {
  @apply bg-nomad-green;
  @apply text-nomad-100;
}

.notification.error {
  @apply bg-nomad-red;
  @apply text-nomad-100;
}

.notification.info {
  @apply bg-nomad-900/90;
  @apply text-nomad-accent;
}
</style>